import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

export default function NotFoundPage() {
    useDocumentTitle("Not found");
    return (
        <Layout>
            <div
                className="mx-auto max-w-md py-16 text-center animate-fade-in-up"
                data-testid="not-found-page"
            >
                <Compass className="mx-auto h-12 w-12 text-primary" />
                <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                    404
                </p>
                <h1 className="mt-2 text-3xl font-semibold tracking-tight text-foreground">
                    Page not found
                </h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    The page you&apos;re looking for has moved or never existed. Let&apos;s get you back somewhere useful.
                </p>
                <div className="mt-8 flex justify-center gap-2">
                    <Button asChild className="bg-primary hover:bg-primary-hover" data-testid="not-found-home-button">
                        <Link to="/">
                            <ArrowLeft className="h-4 w-4" />
                            Back to home
                        </Link>
                    </Button>
                </div>
            </div>
        </Layout>
    );
}
